import ColorSelect from './color-select';

export type { ColorSelectProps, ColorSelectRef, ColorSelectOption } from './color-select';
export { DEFAULT_COLOR_OPTIONS } from './color-select';
export default ColorSelect;
